import { firstNumber, firstPresent, safeText } from './chatArtifactValueUtils';

const NOTICE_SEVERITIES = new Set(['error', 'warning', 'info', 'success']);

function plainText(value) {
  return safeText(value, '');
}

function normalizeExcludedByReason(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
  return Object.fromEntries(
    Object.entries(value)
      .map(([reason, count]) => [reason, firstNumber(count)])
      .filter(([reason, count]) => reason && count !== undefined && count >= 0)
  );
}

export function normalizeNotices(artifact) {
  const notices = firstPresent(artifact?.notices, artifact?.source_notices);
  if (Array.isArray(notices)) {
    return notices.map((notice, index) => {
      if (typeof notice === 'string') {
        const message = notice.trim();
        return message ? {
          code: null,
          severity: null,
          message,
          counts: null,
          key: `legacy-notice-${index}`,
        } : null;
      }

      const message = plainText(firstPresent(notice?.message, notice?.label, notice?.detail)).trim();
      if (!message) return null;
      const severity = NOTICE_SEVERITIES.has(notice?.severity) ? notice.severity : null;
      const code = plainText(notice?.code).trim() || null;
      const counts = notice?.counts && typeof notice.counts === 'object' && !Array.isArray(notice.counts)
        ? notice.counts
        : null;
      return {
        code,
        severity,
        message,
        counts,
        key: `${code || 'notice'}-${index}`,
      };
    }).filter(Boolean);
  }

  return [firstPresent(artifact?.notice, artifact?.source_notice)]
    .filter(Boolean)
    .map((message, index) => ({
      code: null,
      severity: null,
      message: plainText(message),
      counts: null,
      key: `legacy-notice-${index}`,
    }));
}

export function normalizeEligibilityCounts(artifact) {
  const capMetadata = artifact?.cap_metadata || {};
  const retrieved = firstNumber(
    artifact?.retrieved_candidate_count,
    capMetadata?.retrieved_candidate_count
  );
  const eligible = firstNumber(
    artifact?.eligible_candidate_count,
    capMetadata?.eligible_candidate_count
  );
  const excluded = firstNumber(
    artifact?.excluded_candidate_count,
    capMetadata?.excluded_candidate_count
  );
  const contractVersion = plainText(firstPresent(
    artifact?.eligibility_contract_version,
    capMetadata?.eligibility_contract_version
  )).trim() || null;
  const explicit = [retrieved, eligible, excluded].some((value) => value !== undefined) || Boolean(contractVersion);

  return {
    explicit,
    retrieved,
    eligible,
    excluded,
    excludedByReason: normalizeExcludedByReason(firstPresent(
      artifact?.excluded_by_reason,
      capMetadata?.excluded_by_reason
    )),
    contractVersion,
  };
}
